<template>
    <div id="loading">
        <h1>Preparando pedido...</h1>
        <loading></loading>
    </div>
</template>

<script>
    import Loading from './Loading.vue'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        components: {Loading},
        methods:{
            ...mapActions(['loadPedido']),
            cargaPedido(){
                this.loadPedido(this.$route.params)
                    .then(()=>{
                        this.$router.push('/pay')
                    })
                    .catch(()=>{
                        this.$router.push('/not-found')
                    })

            }
        },
        mounted(){
            this.cargaPedido()
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/Prepare.vue